export const CLOTHING_MERCHANDISE_CARD_GRADIENT = 'linear-gradient(180deg,rgba(0,0,0,0.1) 49.97%, rgba(0,0,0,0.5) 100%)';
